import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { logo } from "../assets";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleForgotPassword = async () => {
    if (!email) {
      toast.error("Please enter your email.");
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/forgot-password`, { email });
      toast.success(response.data.message);
    } catch (error) {
      toast.error(error.response?.data?.message || "Error sending reset email.");
    }

    setIsSubmitting(false);
  };

  return (
    <div className="flex max-md:flex-col w-screen h-screen">
      <div className="flex flex-col w-1/2 max-md:w-full h-full max-md:h-[35%] bg-gray-100 justify-center items-center border-r">
        <img src={logo} alt="Thirtify Logo" className="w-24 h-fit rounded-lg object-contain" />
      </div>
      <div className="flex flex-col w-1/2 max-md:w-full h-full max-md:h-[65%] overflow-y-auto scrollbar-hide justify-center items-center">
        <div className="w-full max-w-sm p-6 text-center">
          <h2 className="text-2xl font-bold mb-6">Forgot Password?</h2>
          <p className="mb-4 text-gray-600">Enter your email to receive a password reset link.</p>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            className="w-full p-2 border border-gray-300 rounded mb-4"
            disabled={isSubmitting}
          />
          <button
            onClick={handleForgotPassword}
            className={`w-full py-2 rounded text-white ${isSubmitting ? "bg-gray-400 cursor-not-allowed" : "bg-rose-600 hover:bg-blue-700"}`}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Sending..." : "Send Reset Link"}
          </button>
          <div className="text-center mt-4">
            <button onClick={() => navigate("/login")} className="text-rose-600 hover:underline">
              Back to Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
